module.exports = __webpack_public_path__ + "static/media/IMG_0328.5b72b41f.JPG";